<nav class="navbar navbar-expand-lg navbar-light bg-white shadow-sm">
  <div class="container">
    <!-- Logo -->
    <a class="navbar-brand d-flex align-items-center" routerLink="/" href="/" (click)="closeMenu()">
        <img
    src="/assets/images/home/logo-236.webp"
    srcset="
      /assets/images/home/logo-236.webp 1x,
      /assets/images/home/logo-472.webp 2x
    "
    width="236"
    height="75"
    alt="Maltech logo"
    fetchpriority="high"
  />
    </a>

    <!-- Mobile toggle -->
<button
  class="navbar-toggler"
  type="button"
  (click)="toggleMenu()"
  aria-label="Toggle navigation"
  [attr.aria-expanded]="isMenuOpen"
  aria-controls="navbarNav"
>
  <span class="navbar-toggler-icon"></span>
</button>

    <!-- Navbar links -->
   <div
  id="navbarNav"
  class="navbar-collapse"
  [class.mobile-menu-open]="isMenuOpen"
>
      <ul class="navbar-nav ms-auto">

        <!-- Company -->
        <li class="nav-item dropdown" routerLinkActive="active-parent">
          <button
            class="nav-link dropdown-toggle btn btn-link mb-1"
            type="button"
            (click)="toggleDropdown('company', $event)"
            [attr.aria-expanded]="isDropdownOpen('company')"
          >
            Company <i class="bi bi-chevron-down me-3"></i>
          </button>
          <ul class="dropdown-menu" [class.show]="isDropdownOpen('company')">
            <li><a class="dropdown-item" routerLink="/about" href="/about" routerLinkActive="active-sub" (click)="closeMenu()">About Us</a></li>
            <li><a class="dropdown-item" routerLink="/careers" href="/careers" routerLinkActive="active-sub" (click)="closeMenu()">Careers</a></li>
            <li><a class="dropdown-item" routerLink="/portfolio" href="/portfolio" routerLinkActive="active-sub" (click)="closeMenu()">Portfolio</a></li>
          </ul>
        </li>

        <!-- Services -->
        <li class="nav-item dropdown" routerLinkActive="active-parent">
          <button
            class="nav-link dropdown-toggle btn btn-link mb-1"
            type="button"
            (click)="toggleDropdown('services', $event)"
            [attr.aria-expanded]="isDropdownOpen('services')"
          >
            Services <i class="bi bi-chevron-down me-3"></i>
          </button>
          <ul class="dropdown-menu" [class.show]="isDropdownOpen('services')">
            <li><a class="dropdown-item" routerLink="/service/software-development" href="/service/software-development" routerLinkActive="active-sub" (click)="closeMenu()">Software Development</a></li>
            <li><a class="dropdown-item" routerLink="/service/software-consulting-services" href="/service/software-consulting-services" routerLinkActive="active-sub" (click)="closeMenu()">Software Consulting</a></li>
            <li><a class="dropdown-item" routerLink="/service/ai" href="/service/ai" routerLinkActive="active-sub" (click)="closeMenu()">Artificial Intelligence</a></li>
            <li><a class="dropdown-item" routerLink="/service/quantum-computing" href="/service/quantum-computing" routerLinkActive="active-sub" (click)="closeMenu()">Quantum Computing</a></li>
            <li><a class="dropdown-item" routerLink="/service/ux-design" href="/service/ux-design" routerLinkActive="active-sub" (click)="closeMenu()">UX Design</a></li>
            <li><a class="dropdown-item" routerLink="/service/digital-marketing" href="/service/digital-marketing" routerLinkActive="active-sub" (click)="closeMenu()">Digital Marketing</a></li>
          </ul>
        </li>

        <!-- Products -->
        <li class="nav-item dropdown" routerLinkActive="active-parent">
          <button
            class="nav-link dropdown-toggle btn btn-link mb-1"
            type="button"
            (click)="toggleDropdown('products', $event)"
            [attr.aria-expanded]="isDropdownOpen('products')"
          >
            Products <i class="bi bi-chevron-down me-3"></i>
          </button>
          <ul class="dropdown-menu" [class.show]="isDropdownOpen('products')">
            <li><a class="dropdown-item" routerLink="/product/transactional-emails" href="/product/transactional-emails" routerLinkActive="active-sub" (click)="closeMenu()">Transactional Emails</a></li>
            <li><a class="dropdown-item" routerLink="/product/marketing-emails" href="/product/marketing-emails" routerLinkActive="active-sub" (click)="closeMenu()">Marketing Emails</a></li>
            <li><a class="dropdown-item" routerLink="/product/email-verifier" href="/product/email-verifier" routerLinkActive="active-sub" (click)="closeMenu()">Email Verification</a></li>
            <li><a class="dropdown-item" routerLink="/product/whatsapp-apis" href="/product/whatsapp-apis" routerLinkActive="active-sub" (click)="closeMenu()">WhatsApp APIs</a></li>
            <li><a class="dropdown-item" routerLink="/product/aquatech-digital-twin" href="/product/aquatech-digital-twin" routerLinkActive="active-sub" (click)="closeMenu()">AquaTech Digital Twin</a></li>
          </ul>
        </li>

        <!-- Resources -->
        <li class="nav-item dropdown" routerLinkActive="active-parent">
          <button
            class="nav-link dropdown-toggle btn btn-link mb-1"
            type="button"
            (click)="toggleDropdown('resources', $event)"
            [attr.aria-expanded]="isDropdownOpen('resources')"
          >
            Resources <i class="bi bi-chevron-down me-3"></i>
          </button>
          <ul class="dropdown-menu" [class.show]="isDropdownOpen('resources')">
            <li><a class="dropdown-item"  [href]="blogUrl" (click)="closeMenu()">Blog</a></li>
            <li><a class="dropdown-item" routerLink="/resource/branding" href="/resource/branding" routerLinkActive="active-sub" (click)="closeMenu()">Branding</a></li>
          </ul>
        </li>

        <!-- Contact -->
        <li class="nav-item mb-1" routerLinkActive="active-parent">
          <a
            class="nav-link"
            routerLink="/contact"
            href="/contact"
            (click)="closeMenu()"
          >
            Contact Us
          </a>
        </li>

        <!-- Sign Up -->
        <li class="nav-item mb-1" routerLinkActive="active-parent">
          <a
            class="nav-link"
            [routerLink]="['/signup/']"
            [href]="['/signup/']"
            [queryParams]="{
              utm_source: utmSource,
              utm_medium: utmMedium,
              utm_campaign: utmCampaign,
              utm_content: utmContent
            }"
            (click)="closeMenu()"
          >
            Sign Up
          </a>
        </li>

        <li class="nav-item mb-1" routerLinkActive="active-parent">
  <a class="nav-link" routerLink="/discuss-project" href="/discuss-project" (click)="closeMenu()">Discuss Project</a>
</li>
      </ul>
    </div>
  </div>
</nav>